"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const property_1 = require("../../decorators/property");
const mocks_1 = require("../../mocks");
const constants_1 = require("../../constants");
const doctor_profile_1 = require("./doctor.profile");
const file_record_1 = require("../file/file.record");
const class_validator_1 = require("class-validator");
const searchable_1 = require("../../decorators/searchable");
const restricted_1 = require("../../decorators/restricted");
const class_transformer_1 = require("class-transformer");
const device_profile_1 = require("../conference/device.profile");
let User = class User extends mocks_1.Model {
    constructor() {
        super(...arguments);
        this.balance = 0;
    }
};
exports.User = User;
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.ADMINS, constants_1.GroupEnum.SELF], search: [constants_1.GroupEnum.ADMINS], query: [constants_1.GroupEnum.ADMINS] }),
    (0, searchable_1.Searchable)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)({ index: true, unique: true }),
    __metadata("design:type", String)
], User.prototype, "mobile", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(constants_1.UserTypeEnum),
    (0, property_1.Property)({ type: String, enum: constants_1.UserTypeEnum, index: true }),
    __metadata("design:type", String)
], User.prototype, "type", void 0);
__decorate([
    (0, searchable_1.Searchable)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, { message: 'Name must not exceed 100 characters' }),
    (0, property_1.Property)({ default: '' }),
    __metadata("design:type", String)
], User.prototype, "name", void 0);
__decorate([
    (0, property_1.Property)({ type: mocks_1.ObjectId, required: false }),
    __metadata("design:type", String)
], User.prototype, "imageFileId", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.SELF, constants_1.GroupEnum.ADMINS] }),
    (0, property_1.Property)({ default: 0 }),
    __metadata("design:type", Number)
], User.prototype, "balance", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.ADMINS] }),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], User.prototype, "smsCode", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.SELF, constants_1.GroupEnum.ADMINS] }),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], User.prototype, "fcmToken", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(constants_1.GenderEnum),
    (0, property_1.Property)({ type: String, enum: constants_1.GenderEnum, default: constants_1.GenderEnum.UNKNOWN }),
    __metadata("design:type", String)
], User.prototype, "gender", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.ADMINS] }),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], User.prototype, "os", void 0);
__decorate([
    (0, restricted_1.Whitelist)(),
    (0, property_1.Property)({ type: mocks_1.ObjectId, required: false }),
    __metadata("design:type", String)
], User.prototype, "surveyPendingVisitId", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.ADMINS] }),
    (0, property_1.Property)({ type: () => device_profile_1.DeviceProfile, required: false }),
    __metadata("design:type", device_profile_1.DeviceProfile)
], User.prototype, "lastDeviceProfile", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => doctor_profile_1.DoctorProfile),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", doctor_profile_1.DoctorProfile)
], User.prototype, "doctorProfile", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'imageFileId', ref: 'fs.files' }),
    __metadata("design:type", file_record_1.FileRecord)
], User.prototype, "imageFile", void 0);
__decorate([
    (0, restricted_1.Whitelist)({ read: [constants_1.GroupEnum.SELF] }),
    (0, property_1.Virtual)({ localIdField: 'surveyPendingVisitId', ref: 'Visit' }),
    __metadata("design:type", Function)
], User.prototype, "surveyPendingVisit", void 0);
exports.User = User = __decorate([
    (0, mocks_1.index)({ type: 1, 'doctorProfile.availability.dayOfWeek': 1 }),
    (0, mocks_1.index)({ type: 1, 'doctorProfile.ready': 1 })
], User);
